import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

const Loader: React.FC = () => (
  <Grid container justifyContent="center" alignItems="center" m={5} data-testid="loader-grid">
    <CircularProgress />
  </Grid>
);

export default Loader;
